//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TextField from '~/components/atoms/TextField.vue';

var GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

var GlobalTitle = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalTitle.vue');

export default {
  name: 'SingleFieldForm',
  components: {
    GlobalRichText,
    GlobalTitle,
    TextField
  },
  props: {
    buttonText: {
      type: String,
      required: true
    },
    showError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      required: false,
      default: ''
    },
    inputLabel: {
      type: String,
      required: true
    },
    paragraph: {
      type: Array,
      default: null
    },
    title: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      value: ''
    };
  },

  methods: {
    onSubmit() {
      this.$emit('submit', this.value);
    }

  }
};